export default "__VITE_ASSET__941b7997__"